import { useApp } from "./hooks/AppProvider";
import { Link } from 'react-router-dom'

function UnauthorizedAccess() {
    let app = useApp();

    return (
        <>
            <h1>Accès non autorisé</h1>
            <Link to={"/"}>Accueil</Link>
        </>
    )
}

export default UnauthorizedAccess;